import { BsSearch, BsArrowRepeat, BsEye } from "react-icons/bs";
import { useState, useEffect } from "react";
import { TiInfo } from "react-icons/ti";

const EachPayoutComponent = ({ payout, selectedPayout, setSelectedPayout, setOpenMobilePayoutDetails }) => {
  const [restock, setRestock] = useState(false);
  const [isSelectedPayout, setIsSelectedPayout] = useState(false);

  useEffect(() => {
    if (selectedPayout?._id === payout?._id) {
      setIsSelectedPayout(true);
    } else {
      setIsSelectedPayout(false);
    }
  }, [selectedPayout]);
  /* 
  const selectPayout = (e) => {
    
    let selectedPayout = e.target;
    let parNode = e.target.parentNode;
    console.log(parNode);
    Array.from(parNode.children).forEach((child) => {
     
      child.classList.remove("selectedPayout23");
    });
    selectedPayout.classList.add("selectedPayout23");
  }; */
  let imageUrl = `${payout.product.productImage.split("/upload/")[0]}/upload/f_auto,q_auto,w_40/${payout.product.productImage.split("/upload/")[1]}`;
  return (
    <>
      <div
        id='eachPayoutid34'
        onClick={() => {
          setSelectedPayout(payout);
          setOpenMobilePayoutDetails(true);
        }}
        className={isSelectedPayout ? "EachStock selectedPayout23" : "EachStock"}
      >
        <p style={{ flexGrow: "1.5" }}>
          <img id='payoutImage234' className='stockImageSP' src={imageUrl} /> <span style={{ marginLeft: "8px" }}>{payout.product.name}</span>
        </p>

        <p> {payout.purchasedDate.split("T")[0]} </p>
        <p> {payout.unitPrice} </p>
        <p>{payout.totalPrice}</p>
        <p> {Math.floor(payout.totalPrice - payout.commission)} </p>

        <p className='payoutStatus'>
          {payout.status === "pending" ? (
            <span className='payoutStatusPending'>Pending</span>
          ) : payout.status === "disputed" ? (
            <span className='payoutStatusDisputed'>Disputed</span>
          ) : payout.status === "query" ? (
            <span style={{ backgroundColor: "rgb(137 137 137)", display: "flex", gap: "5px", alignItems: "center" }} className='payoutStatusPaid'>
              <TiInfo color='red' size={10} /> queried
            </span>
          ) : (
            <span className='payoutStatusPaid'>Paid</span>
          )}
        </p>
      </div>
    </>
  );
};

export default EachPayoutComponent;
